import { Array2D } from "@lib/titan2/dist/util/collection/Array2D";
import { Pattern } from "./Pattern";
import { PatternCell } from "./PatternCell";
import { SymbolConfigData } from "./SymbolConfigData";
import { TicketCellData } from "./TicketCellData";
/*
 * InstructionsConfigData.ts
 */
export class InstructionsConfigData {
    constructor() {
        this.rows = this.columns = 5;
        this.reelSymbols = this.createReelSymbols("3,18,41,55,71");
        this.jokerReelSymbols = this.createReelSymbols("J,18,41,55,71");
        this.createTicketCells();
    }
    createTicketCells() {
        let pattern = this.createPattern("0011101110011110110011111");
        let cellSequence = "12,19,37,47,74,14,18,38,50,75,1,19,32,55,71,6,28,35,50,66,7,22,39,57,67";
        let cellValues = cellSequence.split(",");
        let cellIndex = 0;
        this.ticketCells = [];
        for (let row = 0; row < this.rows; row++) {
            for (let column = 0; column < this.columns; column++) {
                let patternCell = pattern.getCell(row, column);
                let cellNumber = parseInt(cellValues[cellIndex++]);
                let ticketCell = new TicketCellData(cellNumber, row, column);
                let matched = patternCell.isActive();
                ticketCell.setDabbed(matched);
                ticketCell.setCalled(matched);
                this.ticketCells.push(ticketCell);
            }
        }
    }
    createReelSymbols(sequence) {
        let sequenceParts = sequence.split(",");
        let symbols = [];
        for (let i = 0; i < sequenceParts.length; i++) {
            symbols.push(SymbolConfigData.getSymbol(sequenceParts[i]));
        }
        return symbols;
    }
    createPattern(pattern) {
        let rows = 5;
        let columns = 5;
        let cells = new Array2D(rows, columns);
        let index = 0;
        for (let row = 0; row < rows; row++) {
            for (let column = 0; column < columns; column++) {
                let cellValue = parseInt(pattern[index++]);
                cells.setValue(row, column, new PatternCell(cellValue));
            }
        }
        return new Pattern(rows, columns, cells);
    }
    getTicketCells() {
        return this.ticketCells?.slice();
    }
    getReelSymbols() {
        return this.reelSymbols?.slice();
    }
    getJokerReelSymbols() {
        return this.jokerReelSymbols?.slice();
    }
}
//# sourceMappingURL=InstructionsConfigData.js.map